import mitt from "mitt";

export enum GlobalEvents {
    SyndicateDetailClosed = "syndicate-detail-closed",
    SyndicateUpdated = "syndicate-updated",
    LobbyShowFavorites = "lobby-show-favorites",
    JackpotsCarouselResize = "jackpots-carousel-resize",
    LaunchCasinoFloating = "launch-casino-floating",
    CasinoGameLayerUpdate = "casino-game-layer-update",
    VideoPopupOpened = "video-popup-opened",
    ConsentsChanged = "consents-changed",
    LoyaltyBet = "loyalty-bet",
    WebLoginStarted = "web-login-started",
    WebLoginAborted = "web-login-aborted",
    PermanentExclusion = "permanent-exclusion",
    TicketFilterActive = "ticket-filter-active",
    TicketFilterInactive = "ticket-filter-inactive",
}

export const eventBus = mitt();
